import styled from 'styled-components'
import CopyField from '@components/CopyField'
import { black, textMuted, border1 } from '@/theme/colors'
import { motion } from '@/theme/tokens'
import { fontSizes, leading } from '@/theme/typography'

export const Divider = styled.hr`
	border: none;
	border-top: 1px solid ${border1};
	margin: 20px 0;
`

export const LoadingText = styled.p`
	font-size: ${fontSizes.small};
	color: ${textMuted};
	margin: 0;
`

export const ShareRow = styled.div<{ $disabled?: boolean }>`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 24px;
	opacity: ${props => (props.$disabled ? 0.5 : 1)};
	transition: opacity ${motion.base};
`

export const ShareText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`

export const ShareTitle = styled.span`
	font-size: ${fontSizes.base};
	font-weight: 700;
	color: ${black};
`

export const ShareDescription = styled.span`
	font-size: ${fontSizes.caption};
	color: ${textMuted};
	line-height: ${leading.body};
`

/** Vertical stack of the per-section toggles. */
export const SectionList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
	margin-top: 20px;
`

/** The master switch and the link it produces, stacked so the link spans the full width. */
export const MasterBlock = styled.div`
	display: flex;
	flex-direction: column;
`

/** The public URL on the app's shared copy-field treatment, under the master switch. */
export const PublicLinkField = styled(CopyField)`
	width: 100%;
	margin-top: 12px;
`

export const ToggleWrapper = styled.div`
	position: relative;
	flex-shrink: 0;
	margin-top: 2px;
`

